/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getMapCustomizedFilters } from '../fn/map-subscription/get-map-customized-filters';
import { GetMapCustomizedFilters$Params } from '../fn/map-subscription/get-map-customized-filters';
import { MapUserCustomizedSearchOptions } from '../models/map-user-customized-search-options';

@Injectable({ providedIn: 'root' })
export class MapSubscriptionService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getMapCustomizedFilters()` */
  static readonly GetMapCustomizedFiltersPath = '/map/filters';

  /**
   * retrieve filters customized based on the user's vehicles.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMapCustomizedFilters()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMapCustomizedFilters$Response(params?: GetMapCustomizedFilters$Params, context?: HttpContext): Observable<StrictHttpResponse<MapUserCustomizedSearchOptions>> {
    return getMapCustomizedFilters(this.http, this.rootUrl, params, context);
  }

  /**
   * retrieve filters customized based on the user's vehicles.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMapCustomizedFilters$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMapCustomizedFilters(params?: GetMapCustomizedFilters$Params, context?: HttpContext): Observable<MapUserCustomizedSearchOptions> {
    return this.getMapCustomizedFilters$Response(params, context).pipe(
      map((r: StrictHttpResponse<MapUserCustomizedSearchOptions>): MapUserCustomizedSearchOptions => r.body)
    );
  }

}
